import { SyntheticEvent } from "react";
import { Box, FormHelperText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SrLabel from "../SrLabel/SrLabel";

type SrFileInputProps = {
  label?: Node;
  name?: string;
  helperText?: string;
  icon?: Node;
  onChange?: (event: SyntheticEvent<HTMLInputElement>) => void;
  onBlur?: (event: SyntheticEvent<HTMLInputElement>) => void;
  error?: boolean;
  children?: Node;
};

const useStyles = makeStyles((theme) => ({
  labelContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: theme.zIndex.mobileStepper,
    cursor: "pointer",
    width: "fit-content",
    height: "fit-content",
    "& span": {
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
      zIndex: theme.zIndex.mobileStepper,
      display: "flex",
      position: "absolute",
      opacity: 0,
      transition: theme.transitions.create("opacity", {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
    "&:hover span": {
      opacity: 1,
    },
    "&:hover $childrenContainer": {
      opacity: 0.3,
    },
  },
  childrenContainer: {
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
    opacity: 1,
  },
  hidden: {
    opacity: 0,
    width: 0,
    height: 0,
    overflow: "hidden",
    position: "absolute",
  },
}));

const SrFileInput = ({
  label,
  name,
  helperText,
  icon,
  onChange,
  onBlur,
  error,
  children,
  ...props
}: SrFileInputProps) => {
  const classes = useStyles();

  return (
    <>
      {label && <SrLabel name={name}>{label}</SrLabel>}
      <Box width="100%" mt={label ? 1 : ""}>
        <label htmlFor={name} className={classes.labelContainer}>
          <span>{icon}</span>
          <input
            className={classes.hidden}
            name={name}
            id={name}
            type="file"
            onChange={onChange}
            onBlur={onBlur}
          />
          <div className={classes.childrenContainer}>{children}</div>
        </label>
        <FormHelperText error id={name}>
          {helperText}
        </FormHelperText>
      </Box>
    </>
  );
};

export default SrFileInput;
